module.exports = __webpack_public_path__ + "img/m.42677fe6.png";